import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  infoBox: {
    display: 'grid',
    gap: theme.spacing(6),
    // @ts-ignore
    maxWidth: theme.container.form.m,
  },
}));

export default useStyles;
